<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="isEdit" class="modal-title">修改保障項目歸類</h3>
          <h3 v-else class="modal-title">新增保障項目歸類</h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-3 text-right"
                    >保障項目歸類</label
                    >
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-3 text-right"
                    >保障項目歸類名稱</label
                    >
                  <div class="col-9">
                    <input
                      type="text"
                      id="categoryName"
                      name="categoryName"
                      placeholder="保障項目歸類名稱"
                      v-model="form.categoryName"
                      :class="{'is-invalid': isCategoryNameError}"
                      class="form-control form-control-inline w-300"
                      maxlength="20"
                      @input="form.categoryName = form.categoryName.trim()"
                      @blur="form.categoryName = form.categoryName.trim()"
                      />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label class="col-3 text-right"
                    >計算方法</label
                    >
                </div>
              </div>
            </div>
          </form>
          <span class="text-red">{{'註：' + (isEdit?'修改':'新增') +'保障項目需與"通路資訊科"人員確認[計算方法]之設定原理'}}</span>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel()" class="btn btn-default editbtn mr-3">取消</a>
            <a @click="isEdit ? doUpdate() : doInsert()" class="btn btn-primary editbtn">確認</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
import { updateCoverageCategoryMain, newCoverageCategoryMain } from "@/service";
export default {
  name: "CoverageKindAddModal",
  mixins: [commonMixin],
  data() {
    return {
      form: {
        categoryName: "",
        categoryId: "",
      },
      isCategoryNameError: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    categoryNameData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  watch: {
    open: "initData",
  },
  methods: {
    initData() {
      this.isCategoryNameError = false;
      if (this.isEdit) {
        this.form.categoryName = this.categoryNameData.categoryName;
        this.form.categoryId = this.categoryNameData.categoryId;
      } else {
        this.form.categoryName = "";
        this.form.categoryId = "";
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.$validator.reset();
      this.$toast.info({ title: this.isEdit ? "取消編輯" : "取消新增" });
    },
    doUpdate() {
      if (this.validateForm()) {
        return;
      }
      updateCoverageCategoryMain(this.$store.state.userInfo.id, this.form).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: "編輯成功" });
            this.$emit("close");
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    doInsert() {
      if (this.validateForm()) {
        return;
      }
      newCoverageCategoryMain(
        this.$store.state.userInfo.id,
        this.form.categoryName
      ).then((result) => {
        if (result.header && result.header.status == "200") {
          this.$toast.info({ title: "新增成功" });
          this.$emit("close");
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });
    },
    validateForm() {
      let isError = false;
      this.isCategoryNameError = false;
      if (!this.form.categoryName) {
        isError = true;
        this.isCategoryNameError = true;
        this.$toast.info({ title: "[保障項目歸類名稱]欄位不得為空" });
      }
      return isError;
    },
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}
.editbtn {
  width: 120px;
  height: 40px;
}
.w-300 {
  width: 300px !important;
}
</style>
